<template>
  <div class="flex flex-row justify-center items-center">
    <div v-if="options && options.length" class="flex flex-wrap gap-4">
      <div
      v-for="option of options"
      :key="option"
      @click="handleClick(option)"
      class="p-2 text-[16px] font-[500] leading-[19px] rounded flex justify-start items-start text-white cursor-pointer hover:opacity-90 active:opacity-80 whitespace-pre-line break-words border border-white bg-transparent break-words whitespace-normal"
      style="word-break: break-word; white-space: normal"
      >
      {{ option }}
      </div>
    </div>
    <div v-else class="text-white text-[16px] font-[500]">
      No Data
    </div>
  </div>
</template>

<script>
import { defaultAgentPrompt } from "./default-agent-prompt";
export default {
  name: "PanelChatInitialOptions",
  emits: ["select"],
  props: {
    agent: {
      type: Object,
      default: null,
    },
  },
  computed: {
    options() {
      console.log("suggested_messages ", this.agent?.suggested_messages);
      const msgs = this.agent?.suggested_messages;
      if (!Array.isArray(msgs) || msgs.length === 0) {
        return defaultAgentPrompt.suggested_messages;
      }
      return msgs;
    },
  },
  methods: {
    handleClick(option) {
      this.$emit("select", option);
    },
  },
  mounted() {
    console.log("PanelChatInitialOptions mounted with options:", this.options);
  },
};
</script>
